//export const SERVICEURL = 'https://prototyp1.mediwiki.org/mediwiki/api/'
//export const SERVICEURL = 'http://localhost:9083/mediwiki/api/'
export const SERVICEURL = 'https://mediwiki.org/mediwiki/api/'

export const localStorageCacheTimeInMinutes = 5

export const searchResultCount = 50
export const entityType = { SPECIALIST: 'SPECIALIST', ORGANIZATION: 'ORGANIZATION' }